// Energy overview - index for energyGroupId
// tanstack
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/',
)({
  beforeLoad: () =>
    redirect({
      to: 'consumption-overview',
      replace: true,
    }),
});
